import {Directive, ElementRef, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {AppealReprocessReason} from './appeal-reprocess-reason';
import {AppealReprocessReasonsService} from '../appeal-reprocess-reasons.service';
declare var $: any;
@Directive({
  selector: '[appAppealReprocessReason]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AppealReprocessReasonDirective),
    multi: true
  }]
})
export class AppealReprocessReasonDirective implements ControlValueAccessor, OnInit {

  @Input() private item: AppealReprocessReason;
  @Input() private disabled = false;
  select2: any;

  constructor(private el: ElementRef, private service: AppealReprocessReasonsService) {
  }

  ngOnInit(): void {
    const that = this;
    this.select2 = $(this.el.nativeElement).select2({
      width: '100%',
      placeholder: 'Select a re-process reason',
      allowClear: true,
      ajax: {
        transport: function(params, success, failure) {
          const page = 1;
          const perPage = 10;
          that.service.getAll().subscribe((ret: Array<AppealReprocessReason>) => {
            success(ret);
          });

        },
        dataType: 'json',
        type: 'GET',
        processResults: function(data) {
          const arr = [];
          data.forEach(function(obj) {
            arr.push({
              id: JSON.stringify(obj),
              text: obj.name,
            });
          });
          return {
            results: arr
          };
        }
      }
    });
    $(this.el.nativeElement).on('select2:select', function(e) {

      that.item = JSON.parse(e.params.data.id);
      that.propagateChange(that.item);

    });

    $(this.el.nativeElement).on('select2:unselect', function(e) {

      that.item = null;
      that.propagateChange(that.item);
    });


  }

  onTouched = () => {
  };

  propagateChange = (_: any) => {
  };

  writeValue(item: AppealReprocessReason): void {

    this.item = item;
    this.propagateChange(this.item);
    const that = this;
    if (this.item !== undefined && this.item !== null) {
      const option = new Option(item.name, JSON.stringify(item), true, true);
      that.select2.append(option);
      that.select2.trigger('change');
    }

  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  get value(): any {
    return this.item;
  }

  set value(v: any) {
    if (v !== this.item) {
      this.item = v;
      this.propagateChange(v);
    }
  }
}
